import { useMemo } from 'react'
import { ITableProps, Row, Table } from 'common-components'
import { ColumnsType } from 'antd/lib/table'
import { localizeDate, openLink } from '@utils'
import { useNavigate, useParams } from 'react-router'
import { getWirkUrl } from '@definitions'
import { useAuth } from 'react-oidc-context'
import { HitType } from '@types'

type ContributorTablePropsType = {
  hitsAchievement: HitType[]
  tableProps?: Partial<ITableProps<HitType>>
}
const ContributorTable = ({ hitsAchievement, tableProps = {} }: ContributorTablePropsType) => {
  const navigate = useNavigate()
  const params = useParams()
  const { user } = useAuth()
  const onHitClick = (idHit: string) => {
    openLink(
      `${getWirkUrl('Form')}/contribute/view/${idHit}?token=${user.access_token}&tenant=${
        params.tenant
      }`,
    )
  }
  const tableColumns: ColumnsType<HitType> = useMemo(
    () => [
      {
        title: 'Traitement',
        dataIndex: 'idHit',
        key: 'idHit',
        render: (idHit: HitType['idHit']) => <Row align={'middle'}>{idHit}</Row>,
      },
      {
        title: 'Date',
        dataIndex: 'supportDateTime',
        key: 'supportDateTime',
        render: (supportDateTime: HitType['supportDateTime']) => (
          <Row align={'middle'}>{localizeDate(supportDateTime)}</Row>
        ),
      },
      /* HIDE
			{
				title: "Temps effectif",
				dataIndex: "effectiveTime",
				key: "effectiveTime",
				render: (effectiveTime) => <Row align={"middle"}>{effectiveTime}</Row>,
			},
			{
				title: "Qualité",
				dataIndex: "quality",
				key: "quality",
				render: (quality) => (
					<Row align={"middle"}>
						<DotComponent activeDots={quality} />
					</Row>
				),
			},*/
    ],
    [],
  )

  const onRowClick = useMemo(
    () => (record: HitType) => ({
      onClick: () => {
        onHitClick(record.idHit)
      },
    }),
    [navigate],
  )

  return <Table onRow={onRowClick} data={hitsAchievement} columns={tableColumns} {...tableProps} />
}

export default ContributorTable
